import React, {Component} from 'react'
import {Select} from 'antd'
import {compose} from 'recompose'

import withSelectFetch from '../withSelectFetch'
import withSpinning from '../../HOC/withSpinning'
import withSort from '../../HOC/withSort'
import withSubDropdown from '../../HOC/withSubDropdown'
import CustomSelect from '../../../elements/Select/CustomSelect'

const Option = Select.Option

class ContractType extends Component {
  render() {
    const {data} = this.props
    return <CustomSelect placeholder={'Select Contract Type'} {...this.props} />
  }
}

export default compose(
  withSelectFetch({dropdown: 'employee', name: 'contract'}),
  withSpinning,
  withSubDropdown({name: 'type'}),
  withSort,
)(ContractType)
